import {Injectable, inject} from "@angular/core";
import {Observable, firstValueFrom} from "rxjs";
import {ThreePLServiceHttpService} from "./threepl-service-http.service";
import {ThreePLServiceDetails} from "../models/threepl-service-details.model";
import {
  TimelineLog,
} from "../../../commons/angular/components/bringoz-timeline-logs-table-row/bringoz-timeline-logs-table-row.component";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {ILogService} from "angular";

@Injectable({providedIn: "root"})
export class ThreePLServiceActionsService {
  private readonly http = inject(ThreePLServiceHttpService);
  private readonly loader = inject<BringozLoaderService>("bringozLoaderService" as never);
  private readonly log = inject<ILogService>("$log" as never);
  private readonly toast = inject<BringozToastService>("bringozToastService" as never);

  getService(serviceId: string): Promise<ThreePLServiceDetails> {
    return firstValueFrom(this.http.getOne(serviceId));
  }

  getTimeline(serviceId: string): Promise<TimelineLog[]> {
    return this.run(this.http.getTimeline(serviceId));
  }

  addNote(serviceIds: string[], note: unknown): Promise<unknown> {
    return this.run(this.http.addNote(serviceIds, note), "THREEPL_SERVICE_ADD_NOTE_SUCCESS", "THREEPL_SERVICE_ADD_NOTE_ERROR");
  }

  cancelService(serviceIds: string[], cancelReason: unknown): Promise<unknown> {
    return this.run(this.http.cancelService(serviceIds, cancelReason), "THREEPL_SERVICE_CANCEL_SUCCESS", "THREEPL_SERVICE_CANCEL_ERROR");
  }

  private run<T>(request: Observable<T>, successKey?: string, errorKey?: string): Promise<T> {
    this.loader.on();
    return firstValueFrom(request)
      .then((result) => {
        if (successKey) {
          this.toast.success({body: successKey});
        }
        return result;
      })
      .catch((error: unknown) => {
        this.log.error(error);
        if (errorKey) {
          this.toast.error({body: errorKey, details: "SOMETHING_WENT_WRONG"});
        }
        throw error;
      })
      .finally(() => this.loader.off());
  }
}
